import { Client } from '@opanuj/shared/types';
import { Database, ref, update } from 'firebase/database';

declare type Profile = {
	displayName?: string | null;
	photoURL?: string | null;
};

type clientUpdateProps = {
	values: Partial<Client>;
	client: Client;
	updateProfile: (profile: Profile) => Promise<boolean>;
	updateEmail: (email: string) => Promise<boolean>;
};

export const clientUpdate = async (
	database: Database,
	{ values, client, updateProfile, updateEmail }: clientUpdateProps
): Promise<void> => {
	const emailUpdated = values.email !== client.email;
	const nameUpdated = values.name !== client.name;
	if (nameUpdated) {
		const success = await updateProfile({ displayName: values.name });
		if (!success) console.error('Display name not updated');
	}
	if (emailUpdated) {
		const success = await updateEmail(values.email!);
		if (!success) console.error('Email not updated');
	}

	const nextValues: Partial<Client> = {
		...client,
		...values,
		billing: {
			...client.billing,
			...(values.billing ?? {}),
		},
		notifications: {
			...client.notifications,
			...(values.notifications ?? {}),
		},
	};

	return update(ref(database, `clients/${client.uid ?? client.id}`), nextValues);
};
